export const PASSWORD_VALIDATION_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,$\/\\ ])[A-Za-z\d@$!%*?&.,$\/\\ ]{8,255}$/;
